/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Reset_LabelInputs */

const en_event_group_metadata_reset_label = /** @type {(inputs: Event_Group_Metadata_Reset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset form fields`)
};

const fr_event_group_metadata_reset_label = /** @type {(inputs: Event_Group_Metadata_Reset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser les champs du formulaire`)
};

const de_event_group_metadata_reset_label = /** @type {(inputs: Event_Group_Metadata_Reset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formularfelder zurücksetzen`)
};

const it_event_group_metadata_reset_label = /** @type {(inputs: Event_Group_Metadata_Reset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reimposta i campi del modulo`)
};

const ru_event_group_metadata_reset_label = /** @type {(inputs: Event_Group_Metadata_Reset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сбросить поля формы`)
};

const es_event_group_metadata_reset_label = /** @type {(inputs: Event_Group_Metadata_Reset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer campos de formulario`)
};

const zh_cn2_event_group_metadata_reset_label = /** @type {(inputs: Event_Group_Metadata_Reset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置表单字段`)
};

const ja_event_group_metadata_reset_label = /** @type {(inputs: Event_Group_Metadata_Reset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォームフィールドをリセットする`)
};

const hi_event_group_metadata_reset_label = /** @type {(inputs: Event_Group_Metadata_Reset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉर्म फ़ील्ड रीसेट करें`)
};

const pt_pt2_event_group_metadata_reset_label = /** @type {(inputs: Event_Group_Metadata_Reset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redefinir campos do formulário`)
};

/**
* | output |
* | --- |
* | "Reset form fields" |
*
* @param {Event_Group_Metadata_Reset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_reset_label = /** @type {((inputs?: Event_Group_Metadata_Reset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Reset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_metadata_reset_label(inputs)
	if (locale === "de") return de_event_group_metadata_reset_label(inputs)
	if (locale === "it") return it_event_group_metadata_reset_label(inputs)
	if (locale === "ru") return ru_event_group_metadata_reset_label(inputs)
	if (locale === "es") return es_event_group_metadata_reset_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_metadata_reset_label(inputs)
	if (locale === "ja") return ja_event_group_metadata_reset_label(inputs)
	if (locale === "hi") return hi_event_group_metadata_reset_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_metadata_reset_label(inputs)
	return en_event_group_metadata_reset_label(inputs)
});